export const GoogleMapApiConfig = 'AIzaSyDpIHuvIcYTBbe0M6rokNaxNHULkiveDWM';